import BlockToolbar from "./BlockToolbar";
import TableEditor from "./TableEditor";

function AnalysisEditor({

  blocks = [],

  setBlocks

}) {

  // AJOUTER BLOC
  const addBlock = (type) => {

    const newBlock = {

      id: Date.now(),

      type,

      content: "",

      style: {

        color: "#ffffff",

        textAlign: "left",

        fontSize: "16px"

      }

    };

    // TABLE
    if (type === "table") {

      newBlock.rows = 2;

      newBlock.cols = 2;

      newBlock.tableData = [

        ["", ""],

        ["", ""]

      ];

    }

    setBlocks([

      ...blocks,

      newBlock

    ]);

  };

  // UPDATE BLOCK
  const updateBlock = (

    id,

    updates

  ) => {

    const updatedBlocks =

      blocks.map(block =>

        block.id === id

          ? {

              ...block,

              ...updates

            }

          : block

      );

    setBlocks(updatedBlocks);

  };

  // DELETE BLOCK
  const deleteBlock = (id) => {

    setBlocks(

      blocks.filter(

        block => block.id !== id

      )

    );

  };

  // ADD ROW
  const addRow = (id) => {

    const updatedBlocks =

      blocks.map(block => {

        if (block.id !== id)
          return block;

        const newRow =

          Array(
            block.cols
          ).fill("");

        return {

          ...block,

          rows:
            block.rows + 1,

          tableData: [

            ...block.tableData,

            newRow

          ]

        };

      });

    setBlocks(updatedBlocks);

  };

  // ADD COLUMN
  const addColumn = (id) => {

    const updatedBlocks =

      blocks.map(block => {

        if (block.id !== id)
          return block;

        return {

          ...block,

          cols:
            block.cols + 1,

          tableData:

            block.tableData.map(row => [

              ...row,

              ""

            ])

        };

      });

    setBlocks(updatedBlocks);

  };

  return (

    <div>

      <BlockToolbar
        addBlock={addBlock}
      />

      {

        Array.isArray(blocks) &&

        blocks.map(block => (

          <div
            key={block.id}
            className="analysis-block"
          >

            {/* TITRE 1 */}

            {

              block.type === "title1" && (

                <input

                  type="text"

                  placeholder="Titre 1"

                  value={block.content}

                  onChange={(e) =>

                    updateBlock(

                      block.id,

                      {

                        content:
                          e.target.value

                      }

                    )

                  }

                />

              )

            }

            {/* TITRE 2 */}

            {

              block.type === "title2" && (

                <input

                  type="text"

                  placeholder="Titre 2"

                  value={block.content}

                  onChange={(e) =>

                    updateBlock(

                      block.id,

                      {

                        content:
                          e.target.value

                      }

                    )

                  }

                />

              )

            }

            {/* PARAGRAPHE */}

            {

              block.type === "paragraph" && (

                <textarea

                  rows="5"

                  placeholder="Paragraphe"

                  value={block.content}

                  onChange={(e) =>

                    updateBlock(

                      block.id,

                      {

                        content:
                          e.target.value

                      }

                    )

                  }

                />

              )

            }

            {/* TABLEAU */}

            {

              block.type === "table" && (

                <>

                  <TableEditor

                    block={block}

                    updateBlock={updateBlock}

                  />

                  <div className="table-controls">

                    <button

                      onClick={() =>

                        addRow(block.id)

                      }

                    >

                      + Ligne

                    </button>

                    <button

                      onClick={() =>

                        addColumn(block.id)

                      }

                    >

                      + Colonne

                    </button>

                  </div>

                </>

              )

            }

            <br />

            {/* STYLE */}

            <div className="block-style-controls">

              {/* COULEUR */}

              <input

                type="color"

                value={

                  block.style?.color ||

                  "#ffffff"

                }

                onChange={(e) =>

                  updateBlock(

                    block.id,

                    {

                      style: {

                        ...block.style,

                        color:
                          e.target.value

                      }

                    }

                  )

                }

              />

              {/* ALIGNEMENT */}

              <select

                value={

                  block.style?.textAlign ||

                  "left"

                }

                onChange={(e) =>

                  updateBlock(

                    block.id,

                    {

                      style: {

                        ...block.style,

                        textAlign:
                          e.target.value

                      }

                    }

                  )

                }

              >

                <option value="left">

                  Gauche

                </option>

                <option value="center">

                  Centre

                </option>

                <option value="right">

                  Droite

                </option>

              </select>

              {/* TAILLE */}

              <input

                type="number"

                value={

                  parseInt(

                    block.style?.fontSize

                  ) || 16

                }

                onChange={(e) =>

                  updateBlock(

                    block.id,

                    {

                      style: {

                        ...block.style,

                        fontSize:
                          `${e.target.value}px`

                      }

                    }

                  )

                }

              />

            </div>

            <br />

            <button

              onClick={() =>

                deleteBlock(block.id)

              }

            >

              Supprimer

            </button>

            <hr />

          </div>

        ))

      }

    </div>

  );

}

export default AnalysisEditor;